export const currencyTranslations = {
  fa: {
    usd: 'دلار آمریکا',
    eur: 'یورو',
    gbp: 'پوند انگلیس',
    chf: 'فرانک سوئیس',
    cad: 'دلار کانادا',
    aud: 'دلار استرالیا',
    sek: 'کرون سوئد',
    nok: 'کرون نروژ',
    rub: 'روبل روسیه',
    thb: 'بات تایلند',
    sgd: 'دلار سنگاپور',
    hkd: 'دلار هنگ کنگ',
    azn: 'منات آذربایجان',
    amd: '۱۰ درام ارمنستان',
    dkk: 'کرون دانمارک',
    aed: 'درهم امارات',
    jpy: '۱۰ ین ژاپن',
    try: 'لیر ترکیه',
    cny: 'یوآن چین',
    sar: 'ریال عربستان',
    inr: 'روپیه هند',
    myr: 'رینگیت مالزی',
    afn: 'افغانی افغانستان',
    kwd: 'دینار کویت',
    iqd: '۱۰۰ دینار عراق',
    bhd: 'دینار بحرین',
    omr: 'ریال عمان',
    qar: 'ریال قطر',
    nzd: 'دلار نیوزیلند',
    krw: 'وون کره جنوبی',
    irr: 'ریال ایران',
    toman: 'تومان',

    // Gold & Metals
    abshodeh: 'مثقال طلا (آبشده)',
    '18ayar': 'طلای ۱۸ عیار',
    ounce: 'انس طلا',
    sekkeh: 'سکه امامی',
    bahar: 'سکه بهار آزادی',
    nim: 'نیم سکه',
    rob: 'ربع سکه',
    gerami: 'سکه گرمی',
  },
  en: {
    usd: 'US Dollar',
    eur: 'Euro',
    gbp: 'British Pound',
    chf: 'Swiss Franc',
    cad: 'Canadian Dollar',
    aud: 'Australian Dollar',
    sek: 'Swedish Krona',
    nok: 'Norwegian Krone',
    rub: 'Russian Ruble',
    thb: 'Thai Baht',
    sgd: 'Singapore Dollar',
    hkd: 'Hong Kong Dollar',
    azn: 'Azerbaijani Manat',
    amd: '10 Armenian Dram',
    dkk: 'Danish Krone',
    aed: 'UAE Dirham',
    jpy: '10 Japanese Yen',
    try: 'Turkish Lira',
    cny: 'Chinese Yuan',
    sar: 'Saudi Riyal',
    inr: 'Indian Rupee',
    myr: 'Malaysian Ringgit',
    afn: 'Afghan Afghani',
    kwd: 'Kuwaiti Dinar',
    iqd: '100 Iraqi Dinar',
    bhd: 'Bahraini Dinar',
    omr: 'Omani Rial',
    qar: 'Qatari Rial',
    nzd: 'New Zealand Dollar',
    krw: 'South Korean Won',
    irr: 'Iranian Rial',
    toman: 'Toman',

    // Gold & Metals
    abshodeh: 'Mithqal (Melted Gold)',
    '18ayar': '18 Karat Gold',
    ounce: 'Gold Ounce',
    sekkeh: 'Emami Gold Coin',
    bahar: 'Bahar Azadi Coin',
    nim: 'Half Azadi Coin',
    rob: 'Quarter Azadi Coin',
    gerami: 'Gerami Coin',
  },
};

export const translations = {
  en: {
    appTitle: 'ArzGoo',
    installApp: 'Install App',
    installTooltip: 'Install App to Home Screen',
    themeLight: 'Switch to Light Theme',
    themeDark: 'Switch to Dark Theme',
    langToggle: 'فارسی',
    langTooltip: 'Switch to Persian',

    // PWA Install Dialog
    installInstructionsTitle: 'Install ArzGoo App',
    installInstructionsDesc: 'To install ArzGoo on your Home Screen:',
    mobileTitle: '📱 Mobile (Chrome / Safari / Edge):',
    mobileStep1: 'Tap the browser Menu (or Share button on iOS)',
    mobileStep2: 'Select "Add to Home Screen" or "Install App".',
    desktopTitle: '💻 Desktop (Chrome / Edge):',
    desktopStep1: 'Click the Install Icon in your browser address bar.',
    ok: 'OK',

    // Market Overview
    liveMarketRates: 'Live Market Rates',
    liveMarketDesc: 'Real-time foreign exchange and precious metals rates updated directly from live financial sources.',
    live: 'Live',
    updating: 'Updating...',
    totalAssets: 'Total Assets',
    quotes: 'Quotes',
    lastUpdated: 'Last Updated',
    loading: 'Loading...',

    // Controls Bar
    allMarkets: 'All Markets',
    currencies: 'Currencies',
    goldMetals: 'Gold & Metals',
    searchPlaceholder: 'Search currency or gold...',
    converter: 'Converter',
    refreshRates: 'Refresh Rates',

    // Currency Card
    sellRate: 'Sell Rate',
    buyRate: 'Buy Rate',
    fxTag: 'FX',
    goldTag: 'Gold',

    // Converter Modal
    currencyConverter: 'Currency Converter',
    amountToConvert: 'Amount to Convert',
    fromCurrency: 'From Currency',
    toCurrency: 'To Currency',
    swapCurrencies: 'Swap Currencies',
    tomanName: 'Iranian Toman',
    toman: 'Toman',

    // Empty State
    noQuotesFound: 'No Quotes Found',
    noQuotesDesc: 'We couldn\'t find any currency or gold item matching "{query}".',
    clearFilters: 'Clear Filters',

    // Reorder Mode
    reorderModeActive: 'Reorder Mode Active',
    dragToReorderDesc: 'Drag and drop cards to rearrange your preferred display order.',
    doneReordering: 'Done',
    resetOrder: 'Reset Order',
    reorder: 'Reorder',
    move: 'Move',
    movePrev: 'Previous',
    moveNext: 'Next',
    selectedTile: 'Selected: {code}',

    // About Page
    about: 'About',
    aboutApp: 'About ArzGoo',
    aboutTagline: 'Smart Real-time Currency, Gold & Coin Exchange Platform',
    aboutDesc: 'ArzGoo is a modern, high-performance financial rates and currency converter platform designed for seamless desktop and mobile use, featuring native iOS Home Screen widgets.',
    version: 'Version',
    features: 'Key Features',
    featLiveRates: 'Live Market Rates',
    featLiveRatesDesc: 'Continuous real-time updates directly from free market sources.',
    featWidgets: 'iOS Home Screen Widgets',
    featWidgetsDesc: 'Multiple size widgets with automatic background refresh.',
    featConverter: 'Smart Converter',
    featConverterDesc: 'Convert any foreign currency to Toman, Rial, and other currencies instantly.',
    featOffline: 'Offline & Standalone PWA',
    featOfflineDesc: 'Full standalone experience with offline caching.',
    developer: 'Developer',
    developedBy: 'Developed by Incognito-Coder',
    sourceCode: 'Source Code (GitHub)',
    disclaimerTitle: 'Disclaimer',
    disclaimerText: 'All rates displayed are solely for informational purposes and should not be considered financial advice.',
  },
  fa: {
    appTitle: 'ارزگو',
    installApp: 'نصب برنامه',
    installTooltip: 'نصب برنامه روی صفحه اصلی',
    themeLight: 'تغییر به پوسته روشن',
    themeDark: 'تغییر به پوسته تاریک',
    langToggle: 'English',
    langTooltip: 'تغییر به زبان انگلیسی',

    // PWA Install Dialog
    installInstructionsTitle: 'نصب برنامه ارزگو',
    installInstructionsDesc: 'برای نصب ارزگو روی صفحه اصلی گوشی یا کامپیوتر:',
    mobileTitle: '📱 موبایل (کروم / سافاری / اج):',
    mobileStep1: 'منوی مرورگر (یا دکمه Share در آیفون) را لمس کنید',
    mobileStep2: 'گزینه «افزودن به صفحه اصلی» یا «Install App» را انتخاب کنید.',
    desktopTitle: '💻 کامپیوتر (کروم / اج):',
    desktopStep1: 'روی آیکون نصب در نوار آدرس مرورگر کلیک کنید.',
    ok: 'متوجه شدم',

    // Market Overview
    liveMarketRates: 'نرخ‌های لحظه‌ای بازار',
    liveMarketDesc: 'نرخ لحظه‌ای ارزهای خارجی و فلزات گرانبها مستقیم از منابع معتبر مالی.',
    live: 'زنده',
    updating: 'بروزرسانی',
    totalAssets: 'کل دارایی‌ها',
    quotes: 'مظنه',
    lastUpdated: 'آخرین به روزرسانی',
    loading: 'در حال بارگذاری...',

    // Controls Bar
    allMarkets: 'همه بازارها',
    currencies: 'ارزها',
    goldMetals: 'طلا و سکه',
    searchPlaceholder: 'جستجوی ارز یا طلا...',
    converter: 'مبدل ارز',
    refreshRates: 'به روزرسانی نرخ‌ها',

    // Currency Card
    sellRate: 'نرخ فروش',
    buyRate: 'نرخ خرید',
    fxTag: 'ارز',
    goldTag: 'طلا',

    // Converter Modal
    currencyConverter: 'مبدل ارز',
    amountToConvert: 'مبلغ جهت تبدیل',
    fromCurrency: 'ارز مبدا',
    toCurrency: 'ارز مقصد',
    swapCurrencies: 'جابجایی ارزها',
    tomanName: 'تومان ایران',
    toman: 'تومان',

    // Empty State
    noQuotesFound: 'موردی یافت نشد',
    noQuotesDesc: 'هیچ ارز یا طلایی با عبارت «{query}» یافت نشد.',
    clearFilters: 'پاک کردن فیلترها',

    // Reorder Mode
    reorderModeActive: 'حالت چیدمان کارت‌ها فعال است',
    dragToReorderDesc: 'برای تغییر ترتیب نمایش، کارت‌ها را بکشید و در موقعیت دلخواه رها کنید.',
    doneReordering: 'اتمام چیدمان',
    resetOrder: 'بازنشانی چیدمان',
    reorder: 'چیدمان',
    move: 'جابجایی',
    movePrev: 'موقعیت قبلی',
    moveNext: 'موقعیت بعدی',
    selectedTile: 'انتخاب شده: {code}',

    // About Page
    about: 'درباره برنامه',
    aboutApp: 'درباره ارزگو',
    aboutTagline: 'سامانه هوشمند استعلام لحظه‌ای و مبدل قیمت ارز، طلا و سکه',
    aboutDesc: 'ارزگو یک پلتفرم مدرن و سریع برای مشاهده نرخ‌های آزاد ارز، طلا و سکه است که با طراحی نئومورفیک، عملکرد روان و پشتیبانی از ویجت‌های نیتیو iOS توسعه یافته است.',
    version: 'نسخه',
    features: 'امکانات و ویژگی‌ها',
    featLiveRates: 'نرخ‌های لحظه‌ای بازار',
    featLiveRatesDesc: 'بروزرسانی مستقیم از قیمت‌های معاملات بازار آزاد.',
    featWidgets: 'ویجت‌های هوم‌اسکرین آیفون',
    featWidgetsDesc: 'ویجت‌های متنوع با پشتیبانی از بروزرسانی خودکار پس‌زمینه در iOS 14 تا 18.',
    featConverter: 'مبدل هوشمند ارز',
    featConverterDesc: 'تبدیل سریع هر ارز به تومان، ریال و سایر ارزها همراه با محاسبه کارمزد.',
    featOffline: 'پشتیبانی آفلاین و PWA',
    featOfflineDesc: 'امکان نصب روی صفحه اصلی و استفاده بدون نیاز به اپ‌استور.',
    developer: 'توسعه‌دهنده',
    developedBy: 'توسعه‌یافته توسط Incognito-Coder',
    sourceCode: 'سورس‌کد پروژه (GitHub)',
    disclaimerTitle: 'سلب مسئولیت',
    disclaimerText: 'تمامی نرخ‌های ثبت‌شده صرفاً جنبه اطلاع‌رسانی داشته و ارزگو مسئولیتی در قبال نوسانات و معاملات بر عهده ندارد.',
  },
};

export const toPersianDigits = (str) => {
  if (str === null || str === undefined) return '';
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return String(str).replace(/[0-9]/g, (w) => farsiDigits[parseInt(w, 10)]);
};

export const parsePersianNumber = (str) => {
  if (str === null || str === undefined) return 0;
  const englishStr = String(str)
    .replace(/[۰٠]/g, '0')
    .replace(/[۱١]/g, '1')
    .replace(/[۲٢]/g, '2')
    .replace(/[۳٣]/g, '3')
    .replace(/[۴٤]/g, '4')
    .replace(/[۵٥]/g, '5')
    .replace(/[۶٦]/g, '6')
    .replace(/[۷٧]/g, '7')
    .replace(/[۸٨]/g, '8')
    .replace(/[۹٩]/g, '9')
    .replace(/,/g, '')
    .replace(/٫/g, '.');
  const val = parseFloat(englishStr);
  return isNaN(val) ? 0 : val;
};

export const formatDigits = (str, lang) => {
  if (str === null || str === undefined) return '';
  return lang === 'fa' ? toPersianDigits(str) : String(str);
};

export const getTranslation = (lang, key, params = {}) => {
  const currentLang = translations[lang] ? lang : 'fa';
  let text = translations[currentLang][key] || translations['en'][key] || key;

  Object.keys(params).forEach((pKey) => {
    const val = currentLang === 'fa' ? toPersianDigits(params[pKey]) : params[pKey];
    text = text.replace(`{${pKey}}`, val);
  });

  return text;
};

export const getCurrencyFullName = (lang, shortCode, defaultName = '') => {
  if (!shortCode) return defaultName;
  const code = String(shortCode).toLowerCase().trim();
  const currentLang = lang === 'fa' ? 'fa' : 'en';
  
  if (currencyTranslations[currentLang] && currencyTranslations[currentLang][code]) {
    return currencyTranslations[currentLang][code];
  }
  
  return defaultName || shortCode;
};
